var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultantH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cha-bubble-female") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SLICES-64px",
    transform: "translate(-360.000000, -100.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ICONS",
    transform: "translate(-355.000000, -95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cha-bubble-female",
    transform: "translate(360.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3262,34.332 L32.0002,44 L24.0002,42 L16.0002,44 L17.6762,34.332 C7.8422,35.489 1.7922,38.024 0.0002,47 C0.0002,49.84 5.7692,50.701 9.3102,50.956 C11.3222,53.906 22.6022,54 24.0002,54 C25.3972,54 36.6782,53.906 38.6892,50.956 C42.2302,50.701 48.0002,49.84 48.0002,47 C46.2202,38.097 40.1592,35.489 30.3262,34.332",
    id: "Fill-17",
    fill: "#4BAADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3262,34.332 C29.8892,34.283 29.4632,34.526 29.2892,34.936 C28.0822,37.784 25.5662,42 24.0002,42 L32.0002,44 L30.3262,34.332 Z",
    id: "Fill-19",
    fill: "#A0DCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,42 C22.438,42 19.922,37.784 18.713,34.936 C18.539,34.526 18.114,34.283 17.676,34.332 L16,44 L24,42 Z",
    id: "Fill-21",
    fill: "#A0DCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,11 C26,10.064 26.165,9.162 26.444,8.295 C25.676,8.109 24.863,8 24,8 C17.836,8 14,13.084 14,17.999 L14,18 L20,18 L22,14 L24,18 L29.207,18 C27.206,16.098 26,13.661 26,11",
    id: "Fill-23",
    fill: "#4BAADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5879,20.7808 L27.9999,23.9998 L29.2889,18.0838 C29.2609,18.0568 29.2349,18.0278 29.2069,17.9998 L23.9999,17.9998 L21.9999,13.9998 L19.9999,17.9998 L13.9999,17.9998 L13.9999,20.9998 C13.9999,22.9628 15.3899,23.9998 16.9999,23.9998 C18.0249,28.5508 19.9999,31.9998 23.9999,31.9998 C27.9999,31.9998 29.9749,28.5468 30.9999,23.9998 C32.5309,23.9998 33.9999,22.9628 33.9999,20.9998 L33.9999,20.9248 C33.8639,20.8738 33.7209,20.8348 33.5879,20.7808",
    id: "Fill-25",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,24 C15.39,24 14,22.963 14,21 L14,20 C14,28.062 10,28.041 10,29 C10,29.959 16,32 24,32 C20,32 18.025,28.551 17,24",
    id: "Fill-27",
    fill: "#4BAADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0293,20.9351 L34.0003,20.9251 L34.0003,21.0001 C34.0003,22.9631 32.5313,24.0001 31.0003,24.0001 C29.9743,28.5471 28.0003,32.0001 24.0003,32.0001 C32.0003,32.0001 38.0003,30.0411 38.0003,29.0001 C38.0003,28.0021 34.3333,28.0351 34.0293,20.9351",
    id: "Fill-29",
    fill: "#4BAADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5879,20.7808 L27.9999,23.9998 L29.2899,18.0838 L29.2909,18.0858 C27.2369,16.1718 25.9999,13.6988 25.9999,10.9998 C25.9999,4.9248 32.2679,-0.0002 39.9999,-0.0002 C47.7329,-0.0002 53.9999,4.9248 53.9999,10.9998 C53.9999,17.0748 47.7329,21.9998 39.9999,21.9998 C37.6889,21.9998 35.5069,21.5598 33.5859,20.7808 L33.5879,20.7808 Z",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,47 C0,49.84 5.77,50.701 9.311,50.956 C11.322,53.906 22.603,54 24,54 C25.397,54 36.678,53.906 38.689,50.956 C42.23,50.701 48,49.84 48,47 C46.22,38.097 40.159,35.489 30.326,34.332 C29.889,34.283 29.463,34.526 29.289,34.936 C28.082,37.784 25.566,42 24,42 C22.437,42 19.922,37.784 18.713,34.936 C18.539,34.526 18.114,34.283 17.676,34.332 C7.842,35.489 1.792,38.024 0,47 Z",
    id: "Stroke-33",
    stroke: "#1E69A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-35",
    stroke: "#1E69A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17.6758 34.332 15.9998 44 23.9998 42 31.9998 44 30.3258 34.332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5879,20.7808 L27.9999,23.9998 L29.2899,18.0838 L29.2909,18.0858 C27.2369,16.1718 25.9999,13.6988 25.9999,10.9998 C25.9999,4.9248 32.2679,-0.0002 39.9999,-0.0002 C47.7329,-0.0002 53.9999,4.9248 53.9999,10.9998 C53.9999,17.0748 47.7329,21.9998 39.9999,21.9998 C37.6889,21.9998 35.5069,21.5598 33.5859,20.7808 L33.5879,20.7808 Z",
    id: "Stroke-37",
    stroke: "#1E69A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,20.9409 L34,20.9999 C34,22.9629 32.531,23.9999 31,23.9999 C29.975,28.5469 28,31.9999 24,31.9999 C20,31.9999 18.025,28.5509 17,23.9999 C15.39,23.9999 14,22.9629 14,20.9999 L14,17.9999 C14,13.0839 17.836,7.9999 24,7.9999 C24.856,7.9999 25.669,8.0989 26.432,8.2809",
    id: "Stroke-39",
    stroke: "#1E69A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-41",
    stroke: "#1E69A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "29.291 18 24 18 22 14 20 18 14 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0195,20.9404 C34.3175,28.0564 37.9995,28.0014 37.9995,29.0004 C37.9995,30.0414 31.9995,32.0004 23.9995,32.0004 C15.9995,32.0004 9.9995,29.9594 9.9995,29.0004 C9.9995,28.0414 13.9995,28.0624 13.9995,20.0004",
    id: "Stroke-43",
    stroke: "#1E69A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultantH);
export default __webpack_public_path__ + "static/media/Consultant-h.7d7b41b03af9fb3b158b54fdeec3f8ac.svg";
export { ForwardRef as ReactComponent };